export default {
  'short sleeve top': {
    svgHtml: `
<svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="160" height="160" fill="#252736"/>
<path opacity="0.3" d="M45.3253 139.733H115.274V68.0533L122.382 74.5244L139.911 58.5955L118.115 28.231L96.3188 20.2666C96.3188 20.2666 90.6313 30.2222 80.1455 29.7244H80.2101C69.7243 30.2222 64.0368 20.2666 64.0368 20.2666L42.2406 28.231L20.4445 58.5955L37.9738 74.5244L45.0819 68.0533V139.733H45.3253Z" stroke="white" stroke-width="2" stroke-miterlimit="10"/>
<!-- 1 -->
<g>
<circle cx="97" cy="20" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M99.5721 15.545C99.8437 15.0937 100 14.5651 100 14C100 12.3431 98.6569 11 97 11C95.3431 11 94 12.3431 94 14C94 14.5651 94.1563 15.0937 94.4279 15.545L97 20L99.5721 15.545Z" fill="#06F2FC"/>
</g>
<!-- 2 -->
<g>
<circle cx="118" cy="28" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M120.572 23.545C120.844 23.0937 121 22.5651 121 22C121 20.3431 119.657 19 118 19C116.343 19 115 20.3431 115 22C115 22.5651 115.156 23.0937 115.428 23.545L118 28L120.572 23.545Z" fill="#06F2FC"/>
</g>
<!-- 3 -->
<g>
<circle cx="115" cy="67" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M117.572 62.545C117.844 62.0937 118 61.5651 118 61C118 59.3431 116.657 58 115 58C113.343 58 112 59.3431 112 61C112 61.5651 112.156 62.0937 112.428 62.545L115 67L117.572 62.545Z" fill="#06F2FC"/>
</g>
<!-- 4 -->
<g>
<circle cx="115" cy="140" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M117.572 135.545C117.844 135.094 118 134.565 118 134C118 132.343 116.657 131 115 131C113.343 131 112 132.343 112 134C112 134.565 112.156 135.094 112.428 135.545L115 140L117.572 135.545Z" fill="#06F2FC"/>
</g>
<!-- 5 -->
<g>
<circle cx="84" cy="140" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M86.5721 135.545C86.8437 135.094 87 134.565 87 134C87 132.343 85.6569 131 84 131C82.3431 131 81 132.343 81 134C81 134.565 81.1563 135.094 81.4279 135.545L84 140L86.5721 135.545Z" fill="#06F2FC"/>
</g>
<!-- 6 -->
<g>
<circle cx="77" cy="140" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M79.5721 135.545C79.8437 135.094 80 134.565 80 134C80 132.343 78.6569 131 77 131C75.3431 131 74 132.343 74 134C74 134.565 74.1563 135.094 74.4279 135.545L77 140L79.5721 135.545Z" fill="#06F2FC"/>
</g>
<!-- 7 -->
<g>
<circle cx="45" cy="140" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M47.5721 135.545C47.8437 135.094 48 134.565 48 134C48 132.343 46.6569 131 45 131C43.3431 131 42 132.343 42 134C42 134.565 42.1563 135.094 42.4279 135.545L45 140L47.5721 135.545Z" fill="#06F2FC"/>
</g>
<!-- 8 -->
<g>
<circle cx="115" cy="78" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M117.572 73.545C117.844 73.0937 118 72.5651 118 72C118 70.3431 116.657 69 115 69C113.343 69 112 70.3431 112 72C112 72.5651 112.156 73.0937 112.428 73.545L115 78L117.572 73.545Z" fill="#06F2FC"/>
</g>
<!-- 9 -->
<g>
<circle cx="45" cy="78" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M47.5721 73.545C47.8437 73.0937 48 72.5651 48 72C48 70.3431 46.6569 69 45 69C43.3431 69 42 70.3431 42 72C42 72.5651 42.1563 73.0937 42.4279 73.545L45 78L47.5721 73.545Z" fill="#06F2FC"/>
</g>
<!-- 10 -->
<g>
<circle cx="37" cy="74" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M39.5721 69.545C39.8437 69.0937 40 68.5651 40 68C40 66.3431 38.6569 65 37 65C35.3431 65 34 66.3431 34 68C34 68.5651 34.1563 69.0937 34.4279 69.545L37 74L39.5721 69.545Z" fill="#06F2FC"/>
</g>
<!-- 11 -->
<g>
<circle cx="20" cy="58" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22.5721 53.545C22.8437 53.0937 23 52.5651 23 52C23 50.3431 21.6569 49 20 49C18.3431 49 17 50.3431 17 52C17 52.5651 17.1563 53.0937 17.4279 53.545L20 58L22.5721 53.545Z" fill="#06F2FC"/>
</g>
<!-- 12 -->
<g>
<circle cx="42" cy="28" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M44.5721 23.545C44.8437 23.0937 45 22.5651 45 22C45 20.3431 43.6569 19 42 19C40.3431 19 39 20.3431 39 22C39 22.5651 39.1563 23.0937 39.4279 23.545L42 28L44.5721 23.545Z" fill="#06F2FC"/>
</g>
</svg>
    `,
    measurements: [
      {
        key: '衣長',
        distanceDefinition: { from: 0, to: [4, 5], distance: 'z' },
        definition: 'short_sleeve_top_length_of_clothing',
      },
      {
        key: '胸寬',
        distanceDefinition: { from: 7, to: 8, distance: 'z' },
        definition: 'short_sleeve_top_width_of_chest',
      },
      {
        key: '袖口',
        distanceDefinition: { from: 9, to: 10, distance: 'z' },
        definition: 'short_sleeve_top_width_of_cuff',
      },
      {
        key: '袖長',
        distanceDefinition: { from: 10, to: 11, distance: 'z' },
        definition: 'short_sleeve_top_length_of_sleeve',
      },
      {
        key: '下擺寬',
        distanceDefinition: { from: 3, to: 6, distance: 'z' },
        definition: 'short_sleeve_top_width_of_hem',
      },
      {
        key: '肩寬',
        distanceDefinition: { from: 1, to: 11, distance: 'z' },
        definition: 'short_sleeve_top_width_of_shoulder',
      },
      {
        key: '袖襱',
        distanceDefinition: { from: 2, to: 1, distance: 'z' },
        definition: 'short_sleeve_top_width_of_sleeve',
      },
    ],
    auxiliaryLines: [
      { auxiliaryPoints: [4], value: 0, referencePoint: { from: 5, to: 5, base: 0 }, rotate: true },
      { auxiliaryPoints: [5], value: 0, referencePoint: { from: 4, to: 4, base: 0 }, rotate: true },
      { auxiliaryPoints: [7, 8], value: 10, referencePoint: { from: 2, to: 2 }, parallel: [4, 5] },
    ],
  },
  'long sleeve top': {
    svgHtml: `
<svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="160" height="160" fill="#252736"/>
<path opacity="0.3" d="M49.1723 135.466H111.069V69.5463L128.272 135.466L144 127.654C144 127.654 126.153 49.2869 121.882 43.1783C109.594 25.5996 94.3522 25.5996 94.3522 25.5996C94.3522 25.5996 93.3741 38.2953 79.7788 37.807H80.2212C66.6259 38.2953 65.6478 25.5996 65.6478 25.5996C65.6478 25.5996 50.406 25.5996 38.1181 43.1783C33.8469 49.2869 16 127.654 16 127.654L31.7284 135.466L48.9314 69.5463V135.466H49.1723Z" stroke="white" stroke-width="2" stroke-miterlimit="10"/>
<!-- 1 -->
<g>
<circle cx="95" cy="25" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M97.5721 20.545C97.8437 20.0937 98 19.5651 98 19C98 17.3431 96.6569 16 95 16C93.3431 16 92 17.3431 92 19C92 19.5651 92.1563 20.0937 92.4279 20.545L95 25L97.5721 20.545Z" fill="#06F2FC"/>
</g>
<!-- 2 -->
<g>
<circle cx="123" cy="44" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M125.572 39.545C125.844 39.0937 126 38.5651 126 38C126 36.3431 124.657 35 123 35C121.343 35 120 36.3431 120 38C120 38.5651 120.156 39.0937 120.428 39.545L123 44L125.572 39.545Z" fill="#06F2FC"/>
</g>
<!-- 3 -->
<g>
<circle cx="111" cy="66" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M113.572 61.545C113.844 61.0937 114 60.5651 114 60C114 58.3431 112.657 57 111 57C109.343 57 108 58.3431 108 60C108 60.5651 108.156 61.0937 108.428 61.545L111 66L113.572 61.545Z" fill="#06F2FC"/>
</g>
<!-- 4 -->
<g>
<circle cx="111" cy="135" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M113.572 130.545C113.844 130.094 114 129.565 114 129C114 127.343 112.657 126 111 126C109.343 126 108 127.343 108 129C108 129.565 108.156 130.094 108.428 130.545L111 135L113.572 130.545Z" fill="#06F2FC"/>
</g>
<!-- 5 -->
<g>
<circle cx="84" cy="135" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M86.5721 130.545C86.8437 130.094 87 129.565 87 129C87 127.343 85.6569 126 84 126C82.3431 126 81 127.343 81 129C81 129.565 81.1563 130.094 81.4279 130.545L84 135L86.5721 130.545Z" fill="#06F2FC"/>
</g>
<!-- 6 -->
<g>
<circle cx="77" cy="135" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M79.5721 130.545C79.8437 130.094 80 129.565 80 129C80 127.343 78.6569 126 77 126C75.3431 126 74 127.343 74 129C74 129.565 74.1563 130.094 74.4279 130.545L77 135L79.5721 130.545Z" fill="#06F2FC"/>
</g>
<!-- 7 -->
<g>
<circle cx="50" cy="135" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M52.5721 130.545C52.8437 130.094 53 129.565 53 129C53 127.343 51.6569 126 50 126C48.3431 126 47 127.343 47 129C47 129.565 47.1563 130.094 47.4279 130.545L50 135L52.5721 130.545Z" fill="#06F2FC"/>
</g>
<!-- 8 -->
<g>
<circle cx="111" cy="78" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M113.572 73.545C113.844 73.0937 114 72.5651 114 72C114 70.3431 112.657 69 111 69C109.343 69 108 70.3431 108 72C108 72.5651 108.156 73.0937 108.428 73.545L111 78L113.572 73.545Z" fill="#06F2FC"/>
</g>
<!-- 9 -->
<g>
<circle cx="49" cy="78" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M51.5721 73.545C51.8437 73.0937 52 72.5651 52 72C52 70.3431 50.6569 69 49 69C47.3431 69 46 70.3431 46 72C46 72.5651 46.1563 73.0937 46.4279 73.545L49 78L51.5721 73.545Z" fill="#06F2FC"/>
</g>
<!-- 10 -->
<g>
<circle cx="32" cy="135" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M34.5721 130.545C34.8437 130.094 35 129.565 35 129C35 127.343 33.6569 126 32 126C30.3431 126 29 127.343 29 129C29 129.565 29.1563 130.094 29.4279 130.545L32 135L34.5721 130.545Z" fill="#06F2FC"/>
</g>
<!-- 11 -->
<g>
<circle cx="16" cy="128" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.5721 123.545C18.8437 123.094 19 122.565 19 122C19 120.343 17.6569 119 16 119C14.3431 119 13 120.343 13 122C13 122.565 13.1563 123.094 13.4279 123.545L16 128L18.5721 123.545Z" fill="#06F2FC"/>
</g>
<!-- 12 -->
<g>
<circle cx="37" cy="44" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M39.5721 39.545C39.8437 39.0937 40 38.5651 40 38C40 36.3431 38.6569 35 37 35C35.3431 35 34 36.3431 34 38C34 38.5651 34.1563 39.0937 34.4279 39.545L37 44L39.5721 39.545Z" fill="#06F2FC"/>
</g>
</svg>
    `,
    measurements: [
      {
        key: '衣長',
        distanceDefinition: { from: 0, to: [4, 5], distance: 'z' },
        definition: 'long_sleeve_top_length_of_clothing',
      },
      {
        key: '胸寬',
        distanceDefinition: { from: 7, to: 8, distance: 'z' },
        definition: 'long_sleeve_top_width_of_chest',
      },
      {
        key: '袖口',
        distanceDefinition: { from: 9, to: 10, distance: 'z' },
        definition: 'long_sleeve_top_width_of_cuff',
      },
      {
        key: '袖長',
        distanceDefinition: { from: 10, to: 11, distance: 'z' },
        definition: 'long_sleeve_top_length_of_sleeve',
      },
      {
        key: '下擺寬',
        distanceDefinition: { from: 3, to: 6, distance: 'z' },
        definition: 'long_sleeve_top_width_of_hem',
      },
      {
        key: '肩寬',
        distanceDefinition: { from: 1, to: 11, distance: 'z' },
        definition: 'long_sleeve_top_width_of_shoulder',
      },
      {
        key: '袖襱',
        distanceDefinition: { from: 1, to: 2, distance: 'z' },
        definition: 'long_sleeve_top_width_of_sleeve',
      },
    ],
    auxiliaryLines: [
      { auxiliaryPoints: [4], value: 0, referencePoint: { from: 5, to: 5, base: 0 }, rotate: true },
      { auxiliaryPoints: [5], value: 0, referencePoint: { from: 4, to: 4, base: 0 }, rotate: true },
      { auxiliaryPoints: [7, 8], value: 10, referencePoint: { from: 2, to: 2 }, parallel: [4, 5] },
    ],
  },
  'long sleeve outwear': {
    svgHtml: `
<svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="160" height="160" fill="#252736"/>
<path opacity="0.3" d="M80.0002 67.893L66.5392 27.5391M80.0002 67.893V135.467M80.0002 67.893L93.4612 27.5391M66.5392 27.5391C66.5392 27.5391 59.8086 34.7452 44.4246 36.1864C41.5112 36.4602 11.7335 114.012 11.7335 114.012L29.5213 122.659L49.4629 77.2609L49.2321 133.228L80.0002 135.467M66.5392 27.5391C66.5392 27.5391 67.9814 24.4165 80.0002 24.5366C92.019 24.4165 93.4612 27.5391 93.4612 27.5391M80.0002 135.467L110.768 133.228L110.537 77.2609L130.479 122.659L148.267 114.012C148.267 114.012 118.489 36.4602 115.576 36.1864C100.192 34.7452 93.4612 27.5391 93.4612 27.5391" stroke="white" stroke-width="2" stroke-miterlimit="10"/>
<!-- 1 -->
<g>
<circle cx="94" cy="28" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M96.5721 23.545C96.8437 23.0937 97 22.5651 97 22C97 20.3431 95.6569 19 94 19C92.3431 19 91 20.3431 91 22C91 22.5651 91.1563 23.0937 91.4279 23.545L94 28L96.5721 23.545Z" fill="#06F2FC"/>
</g>
<!-- 2 -->
<g>
<circle cx="116" cy="36" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M118.572 31.545C118.844 31.0937 119 30.5651 119 30C119 28.3431 117.657 27 116 27C114.343 27 113 28.3431 113 30C113 30.5651 113.156 31.0937 113.428 31.545L116 36L118.572 31.545Z" fill="#06F2FC"/>
</g>
<!-- 3 -->
<g>
<circle cx="111" cy="76" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M113.572 71.545C113.844 71.0937 114 70.5651 114 70C114 68.3431 112.657 67 111 67C109.343 67 108 68.3431 108 70C108 70.5651 108.156 71.0937 108.428 71.545L111 76L113.572 71.545Z" fill="#06F2FC"/>
</g>
<!-- 4 -->
<g>
<circle cx="111" cy="133" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M113.572 128.545C113.844 128.094 114 127.565 114 127C114 125.343 112.657 124 111 124C109.343 124 108 125.343 108 127C108 127.565 108.156 128.094 108.428 128.545L111 133L113.572 128.545Z" fill="#06F2FC"/>
</g>
<!-- 5 -->
<g>
<circle cx="84" cy="136" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M86.5721 131.545C86.8437 131.094 87 130.565 87 130C87 128.343 85.6569 127 84 127C82.3431 127 81 128.343 81 130C81 130.565 81.1563 131.094 81.4279 131.545L84 136L86.5721 131.545Z" fill="#06F2FC"/>
</g>
<!-- 6 -->
<g>
<circle cx="77" cy="136" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M79.5721 131.545C79.8437 131.094 80 130.565 80 130C80 128.343 78.6569 127 77 127C75.3431 127 74 128.343 74 130C74 130.565 74.1563 131.094 74.4279 131.545L77 136L79.5721 131.545Z" fill="#06F2FC"/>
</g>
<!-- 7 -->
<g>
<circle cx="49" cy="133" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M51.5721 128.545C51.8437 128.094 52 127.565 52 127C52 125.343 50.6569 124 49 124C47.3431 124 46 125.343 46 127C46 127.565 46.1563 128.094 46.4279 128.545L49 133L51.5721 128.545Z" fill="#06F2FC"/>
</g>
<!-- 8 -->
<g>
<circle cx="111" cy="87" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M113.572 82.545C113.844 82.0937 114 81.5651 114 81C114 79.3431 112.657 78 111 78C109.343 78 108 79.3431 108 81C108 81.5651 108.156 82.0937 108.428 82.545L111 87L113.572 82.545Z" fill="#06F2FC"/>
</g>
<!-- 9 -->
<g>
<circle cx="49" cy="87" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M51.5721 82.545C51.8437 82.0937 52 81.5651 52 81C52 79.3431 50.6569 78 49 78C47.3431 78 46 79.3431 46 81C46 81.5651 46.1563 82.0937 46.4279 82.545L49 87L51.5721 82.545Z" fill="#06F2FC"/>
</g>
<!-- 10 -->
<g>
<circle cx="30" cy="122" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M32.5721 117.545C32.8437 117.094 33 116.565 33 116C33 114.343 31.6569 113 30 113C28.3431 113 27 114.343 27 116C27 116.565 27.1563 117.094 27.4279 117.545L30 122L32.5721 117.545Z" fill="#06F2FC"/>
</g>
<!-- 11 -->
<g>
<circle cx="12" cy="114" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.5721 109.545C14.8437 109.094 15 108.565 15 108C15 106.343 13.6569 105 12 105C10.3431 105 9 106.343 9 108C9 108.565 9.15625 109.094 9.42792 109.545L12 114L14.5721 109.545Z" fill="#06F2FC"/>
</g>
<!-- 12 -->
<g>
<circle cx="44" cy="36" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M46.5721 31.545C46.8437 31.0937 47 30.5651 47 30C47 28.3431 45.6569 27 44 27C42.3431 27 41 28.3431 41 30C41 30.5651 41.1563 31.0937 41.4279 31.545L44 36L46.5721 31.545Z" fill="#06F2FC"/>
</g>
</svg>
    `,
    measurements: [
      {
        key: '衣長',
        distanceDefinition: { from: 0, to: [4, 5], distance: 'z' },
        definition: 'long_sleeve_outwear_length_of_clothing',
      },
      {
        key: '胸寬',
        distanceDefinition: { from: 7, to: 8, distance: 'z' },
        definition: 'long_sleeve_outwear_width_of_chest',
      },
      {
        key: '袖口',
        distanceDefinition: { from: 9, to: 10, distance: 'z' },
        definition: 'long_sleeve_outwear_width_of_cuff',
      },
      {
        key: '袖長',
        distanceDefinition: { from: 10, to: 11, distance: 'z' },
        definition: 'long_sleeve_outwear_length_of_sleeve',
      },
      {
        key: '下擺寬',
        distanceDefinition: { from: 3, to: 6, distance: 'z' },
        definition: 'long_sleeve_outwear_width_of_hem',
      },
      {
        key: '肩寬',
        distanceDefinition: { from: 1, to: 11, distance: 'z' },
        definition: 'long_sleeve_outwear_width_of_shoulder',
      },
      {
        key: '袖襱',
        distanceDefinition: { from: 1, to: 2, distance: 'z' },
        definition: 'long_sleeve_outwear_width_of_sleeve',
      },
    ],
    auxiliaryLines: [
      { auxiliaryPoints: [4], value: 0, referencePoint: { from: 5, to: 5, base: 0 }, rotate: true },
      { auxiliaryPoints: [5], value: 0, referencePoint: { from: 4, to: 4, base: 0 }, rotate: true },
      { auxiliaryPoints: [7, 8], value: 10, referencePoint: { from: 2, to: 2 }, parallel: [4, 5] },
    ],
  },
  vest: {
    svgHtml: `
<svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="160" height="160" fill="#252736"/>
<path opacity="0.3" d="M81.0025 32.7105C97.0554 32.7105 100.158 20.2666 100.158 20.2666H108.698C108.698 20.2666 105.037 66.558 121 73.5266V139.733H41V73.5266C56.9631 66.558 53.3016 20.2666 53.3016 20.2666H61.8418C61.8468 20.2666 64.9496 32.7105 81.0025 32.7105Z" stroke="white" stroke-width="2" stroke-miterlimit="10"/>
<!-- 1 -->
<g>
<circle cx="100" cy="20" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M102.572 15.545C102.844 15.0937 103 14.5651 103 14C103 12.3431 101.657 11 100 11C98.3431 11 97 12.3431 97 14C97 14.5651 97.1563 15.0937 97.4279 15.545L100 20L102.572 15.545Z" fill="#06F2FC"/>
</g>
<!-- 2 -->
<g>
<circle cx="108" cy="20" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M110.572 15.545C110.844 15.0937 111 14.5651 111 14C111 12.3431 109.657 11 108 11C106.343 11 105 12.3431 105 14C105 14.5651 105.156 15.0937 105.428 15.545L108 20L110.572 15.545Z" fill="#06F2FC"/>
</g>
<!-- 3 -->
<g>
<circle cx="121" cy="73" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M123.572 68.545C123.844 68.0937 124 67.5651 124 67C124 65.3431 122.657 64 121 64C119.343 64 118 65.3431 118 67C118 67.5651 118.156 68.0937 118.428 68.545L121 73L123.572 68.545Z" fill="#06F2FC"/>
</g>
<!-- 4 -->
<g>
<circle cx="121" cy="139" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M123.572 134.545C123.844 134.094 124 133.565 124 133C124 131.343 122.657 130 121 130C119.343 130 118 131.343 118 133C118 133.565 118.156 134.094 118.428 134.545L121 139L123.572 134.545Z" fill="#06F2FC"/>
</g>
<!-- 5 -->
<g>
<circle cx="84" cy="139" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M86.5721 134.545C86.8437 134.094 87 133.565 87 133C87 131.343 85.6569 130 84 130C82.3431 130 81 131.343 81 133C81 133.565 81.1563 134.094 81.4279 134.545L84 139L86.5721 134.545Z" fill="#06F2FC"/>
</g>
<!-- 6 -->
<g>
<circle cx="77" cy="139" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M79.5721 134.545C79.8437 134.094 80 133.565 80 133C80 131.343 78.6569 130 77 130C75.3431 130 74 131.343 74 133C74 133.565 74.1563 134.094 74.4279 134.545L77 139L79.5721 134.545Z" fill="#06F2FC"/>
</g>
<!-- 7 -->
<g>
<circle cx="41" cy="139" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M43.5721 134.545C43.8437 134.094 44 133.565 44 133C44 131.343 42.6569 130 41 130C39.3431 130 38 131.343 38 133C38 133.565 38.1563 134.094 38.4279 134.545L41 139L43.5721 134.545Z" fill="#06F2FC"/>
</g>
<!-- 8 -->
<g>
<circle cx="121" cy="84" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M123.572 79.545C123.844 79.0937 124 78.5651 124 78C124 76.3431 122.657 75 121 75C119.343 75 118 76.3431 118 78C118 78.5651 118.156 79.0937 118.428 79.545L121 84L123.572 79.545Z" fill="#06F2FC"/>
</g>
<!-- 9 -->
<g>
<circle cx="41" cy="84" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M43.5721 79.545C43.8437 79.0937 44 78.5651 44 78C44 76.3431 42.6569 75 41 75C39.3431 75 38 76.3431 38 78C38 78.5651 38.1563 79.0937 38.4279 79.545L41 84L43.5721 79.545Z" fill="#06F2FC"/>
</g>
<!-- 10 -->
<g>
<circle cx="53" cy="20" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M55.5721 15.545C55.8437 15.0937 56 14.5651 56 14C56 12.3431 54.6569 11 53 11C51.3431 11 50 12.3431 50 14C50 14.5651 50.1563 15.0937 50.4279 15.545L53 20L55.5721 15.545Z" fill="#06F2FC"/>
</g>
</svg>
    `,
    measurements: [
      {
        key: '衣長',
        distanceDefinition: { from: 0, to: [4, 5], distance: 'z' },
        definition: 'vest_length_of_clothing',
      },
      {
        key: '胸寬',
        distanceDefinition: { from: 7, to: 8, distance: 'z' },
        definition: 'vest_width_of_chest',
      },
      {
        key: '下擺寬',
        distanceDefinition: { from: 3, to: 6, distance: 'z' },
        definition: 'vest_width_of_hem',
      },
      {
        key: '肩寬',
        distanceDefinition: { from: 1, to: 9, distance: 'z' },
        definition: 'vest_width_of_shoulder',
      },
      {
        key: '袖襱',
        distanceDefinition: { from: 1, to: 2, distance: 'z' },
        definition: 'vest_length_of_sleeve',
      },
    ],
    auxiliaryLines: [
      { auxiliaryPoints: [4], value: 0, referencePoint: { from: 5, to: 5, base: 0 }, rotate: true },
      { auxiliaryPoints: [5], value: 0, referencePoint: { from: 4, to: 4, base: 0 }, rotate: true },
      { auxiliaryPoints: [7, 8], value: 10, referencePoint: { from: 2, to: 2 }, parallel: [4, 5] },
    ],
  },
  trousers: {
    svgHtml: `  
<svg width="180" height="160" viewBox="0 0 180 160" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="180" height="160" fill="#252736"/>
<path d="M85.1645 42.3824L84.2366 42.0096L84.1645 42.189V42.3824H85.1645ZM107.425 149.511L106.441 149.691L106.626 150.703L107.633 150.489L107.425 149.511ZM128.111 145.114L128.319 146.092L129.178 145.909L129.108 145.033L128.111 145.114ZM117.682 16L118.679 15.9195L118.597 14.9082L117.587 15.0045L117.682 16ZM89.6615 17.9987L89.6621 16.9987H89.6615V17.9987ZM61.8656 16L61.9611 15.0046L60.9505 14.9076L60.8688 15.9195L61.8656 16ZM51.437 145.114L50.4403 145.033L50.3695 145.909L51.2291 146.092L51.437 145.114ZM72.1232 149.511L71.9153 150.489L72.922 150.703L73.107 149.691L72.1232 149.511ZM89.774 52.8754L90.7577 52.6958C90.6709 52.2206 90.257 51.8754 89.774 51.8754C89.291 51.8754 88.877 52.2206 88.7902 52.6958L89.774 52.8754ZM89.7741 22.5753L89.7735 23.5753H89.7735L89.7741 22.5753ZM88.7818 17.874C87.6046 27.2419 86.4574 33.3042 85.6091 37.0129C85.185 38.8669 84.8359 40.1311 84.5957 40.9247C84.4755 41.3215 84.3827 41.6003 84.3214 41.7763C84.2908 41.8642 84.2681 41.9264 84.2537 41.9647C84.2466 41.9838 84.2415 41.997 84.2387 42.0044C84.2372 42.0081 84.2363 42.0104 84.236 42.0112C84.2358 42.0117 84.2358 42.0117 84.2359 42.0115C84.236 42.0113 84.236 42.0111 84.2362 42.0108C84.2362 42.0106 84.2363 42.0103 84.2364 42.0103C84.2365 42.0099 84.2366 42.0096 85.1645 42.3824C86.0924 42.7552 86.0926 42.7549 86.0928 42.7545C86.0928 42.7543 86.093 42.7539 86.0931 42.7535C86.0934 42.7529 86.0937 42.7522 86.094 42.7513C86.0947 42.7497 86.0955 42.7477 86.0964 42.7454C86.0982 42.7407 86.1006 42.7347 86.1035 42.7272C86.1093 42.7123 86.1171 42.6917 86.127 42.6653C86.1468 42.6124 86.1747 42.536 86.2101 42.4342C86.281 42.2307 86.3823 41.9256 86.5099 41.5042C86.765 40.6614 87.1256 39.3523 87.5587 37.4588C88.4249 33.6725 89.5825 27.5429 90.7662 18.1234L88.7818 17.874ZM84.1645 42.3824C84.1645 42.7857 84.2734 43.2486 84.4057 43.6846C84.5445 44.1421 84.7375 44.6585 84.9601 45.1991C85.4059 46.2815 85.9946 47.5183 86.5753 48.6767C87.1575 49.838 87.7388 50.9344 88.174 51.7395C88.3918 52.1424 88.5734 52.4731 88.7008 52.7035C88.7644 52.8187 88.8146 52.9088 88.8489 52.9704C88.8661 53.0011 88.8794 53.0248 88.8884 53.0409C88.8929 53.0489 88.8963 53.055 88.8987 53.0592C88.8998 53.0613 88.9007 53.0629 88.9014 53.064C88.9017 53.0646 88.9019 53.065 88.9021 53.0653C88.9022 53.0655 88.9023 53.0656 88.9023 53.0657C88.9024 53.0658 88.9024 53.0659 89.774 52.5756C90.6455 52.0854 90.6456 52.0854 90.6455 52.0854C90.6455 52.0853 90.6455 52.0853 90.6454 52.0852C90.6453 52.085 90.6452 52.0847 90.6449 52.0842C90.6444 52.0834 90.6437 52.082 90.6426 52.0801C90.6405 52.0764 90.6374 52.0708 90.6331 52.0633C90.6247 52.0482 90.6121 52.0256 90.5955 51.9959C90.5623 51.9364 90.5134 51.8486 90.4511 51.7358C90.3263 51.5102 90.1478 51.1851 89.9335 50.7885C89.5044 49.9947 88.9333 48.9175 88.3632 47.7803C87.7916 46.6402 87.2279 45.4537 86.8094 44.4375C86.5999 43.9288 86.4328 43.4771 86.3195 43.1039C86.1997 42.7092 86.1645 42.4788 86.1645 42.3824H84.1645ZM107.633 150.489L128.319 146.092L127.903 144.136L107.217 148.533L107.633 150.489ZM129.108 145.033L118.679 15.9195L116.686 16.0805L127.114 145.194L129.108 145.033ZM117.682 16C117.587 15.0045 117.587 15.0045 117.587 15.0045C117.587 15.0046 117.587 15.0046 117.587 15.0046C117.586 15.0047 117.585 15.0048 117.584 15.0049C117.581 15.0051 117.577 15.0055 117.572 15.0059C117.562 15.0069 117.547 15.0083 117.527 15.0102C117.488 15.014 117.429 15.0196 117.351 15.0269C117.196 15.0415 116.967 15.063 116.674 15.0904C116.087 15.145 115.24 15.2232 114.203 15.3169C112.127 15.5044 109.286 15.7544 106.226 16.0041C100.088 16.5053 93.1272 17.0006 89.6621 16.9987L89.661 18.9987C93.2247 19.0007 100.274 18.4967 106.389 17.9975C109.456 17.7471 112.303 17.4967 114.383 17.3088C115.422 17.2149 116.271 17.1366 116.859 17.0817C117.154 17.0543 117.383 17.0328 117.539 17.0181C117.617 17.0107 117.676 17.0051 117.716 17.0013C117.736 16.9994 117.752 16.9979 117.762 16.997C117.767 16.9965 117.771 16.9961 117.773 16.9959C117.775 16.9957 117.776 16.9956 117.776 16.9956C117.777 16.9955 117.777 16.9955 117.777 16.9955C117.777 16.9955 117.777 16.9955 117.682 16ZM89.6615 16.9987C86.2257 16.9987 79.3208 16.5033 73.2316 16.0027C70.1964 15.7532 67.3784 15.5036 65.319 15.3164C64.2894 15.2228 63.4496 15.1448 62.8674 15.0902C62.5762 15.063 62.3495 15.0415 62.1956 15.0269C62.1187 15.0196 62.06 15.014 62.0205 15.0103C62.0008 15.0084 61.9859 15.007 61.976 15.006C61.971 15.0055 61.9673 15.0052 61.9648 15.0049C61.9635 15.0048 61.9626 15.0047 61.962 15.0047C61.9617 15.0046 61.9615 15.0046 61.9613 15.0046C61.9612 15.0046 61.9611 15.0046 61.8656 16C61.77 16.9954 61.7701 16.9954 61.7703 16.9955C61.7705 16.9955 61.7707 16.9955 61.771 16.9955C61.7717 16.9956 61.7727 16.9957 61.774 16.9958C61.7765 16.996 61.7803 16.9964 61.7854 16.9969C61.7955 16.9979 61.8106 16.9993 61.8305 17.0012C61.8703 17.005 61.9294 17.0106 62.0067 17.018C62.1613 17.0326 62.3888 17.0542 62.6807 17.0815C63.2646 17.1362 64.1063 17.2144 65.138 17.3082C67.2012 17.4957 70.0252 17.7458 73.0677 17.996C79.134 18.4947 86.1271 18.9987 89.6615 18.9987V16.9987ZM60.8688 15.9195L50.4403 145.033L52.4338 145.194L62.8623 16.0805L60.8688 15.9195ZM51.2291 146.092L71.9153 150.489L72.3311 148.533L51.6449 144.136L51.2291 146.092ZM73.107 149.691L90.7577 53.0551L88.7902 52.6958L71.1395 149.331L73.107 149.691ZM88.7902 53.0551L106.441 149.691L108.408 149.331L90.7577 52.6958L88.7902 53.0551ZM89.7746 21.5753C86.2888 21.5733 79.3379 21.0297 73.2121 20.4805C70.1593 20.2068 67.3269 19.9332 65.2576 19.7279C64.223 19.6253 63.3793 19.5399 62.7945 19.48C62.5021 19.4501 62.2744 19.4266 62.1199 19.4106C62.0426 19.4026 61.9836 19.3965 61.944 19.3924C61.9242 19.3903 61.9093 19.3888 61.8993 19.3877C61.8943 19.3872 61.8905 19.3868 61.8881 19.3865C61.8868 19.3864 61.8859 19.3863 61.8853 19.3863C61.885 19.3862 61.8847 19.3862 61.8846 19.3862C61.8844 19.3862 61.8844 19.3862 61.7802 20.3807C61.6761 21.3753 61.6762 21.3753 61.6763 21.3753C61.6765 21.3753 61.6768 21.3754 61.6771 21.3754C61.6777 21.3755 61.6787 21.3756 61.68 21.3757C61.6826 21.376 61.6864 21.3764 61.6915 21.3769C61.7017 21.378 61.7168 21.3795 61.7368 21.3816C61.7768 21.3858 61.8362 21.392 61.9138 21.4C62.0691 21.4161 62.2977 21.4397 62.591 21.4697C63.1776 21.5297 64.0233 21.6153 65.0602 21.7182C67.1337 21.9238 69.9726 22.1981 73.0335 22.4725C79.135 23.0195 86.181 23.5732 89.7735 23.5753L89.7746 21.5753ZM117.993 20.3807C117.889 19.3861 117.889 19.3861 117.889 19.3861C117.889 19.3861 117.888 19.3862 117.888 19.3862C117.888 19.3863 117.887 19.3864 117.885 19.3865C117.883 19.3868 117.879 19.3872 117.874 19.3877C117.864 19.3887 117.849 19.3903 117.829 19.3924C117.789 19.3965 117.73 19.4027 117.652 19.4107C117.496 19.4267 117.266 19.4503 116.972 19.4803C116.382 19.5403 115.531 19.6261 114.488 19.729C112.402 19.9349 109.547 20.2092 106.469 20.4834C100.294 21.0337 93.2871 21.5772 89.7746 21.5753L89.7735 23.5753C93.3933 23.5773 100.496 23.0236 106.647 22.4755C109.732 22.2006 112.594 21.9256 114.685 21.7193C115.73 21.6162 116.583 21.5302 117.174 21.47C117.47 21.4399 117.7 21.4163 117.857 21.4001C117.935 21.3921 117.995 21.3859 118.035 21.3817C118.055 21.3796 118.071 21.378 118.081 21.377C118.086 21.3764 118.09 21.376 118.092 21.3757C118.094 21.3756 118.095 21.3755 118.095 21.3754C118.096 21.3754 118.096 21.3754 118.096 21.3754C118.096 21.3753 118.096 21.3753 117.993 20.3807Z" fill="white" opacity="0.3" />
<path d="M86 39C86 39 91.8249 43 95 55.5C99.2452 72.2129 106.225 116.542 111.5 149.5" opacity="0.3" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-dasharray="4 4"/>
<!-- 1 -->
<g>
<circle cx="62" cy="16" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M64.5721 11.545C64.8437 11.0937 65 10.5651 65 10C65 8.34315 63.6569 7 62 7C60.3431 7 59 8.34315 59 10C59 10.5651 59.1563 11.0937 59.4279 11.545L62 16L64.5721 11.545Z" fill="#06F2FC"/>
</g>
<!-- 2 -->
<g>
<circle cx="90" cy="18" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M92.5721 13.545C92.8437 13.0937 93 12.5651 93 12C93 10.3431 91.6569 9 90 9C88.3431 9 87 10.3431 87 12C87 12.5651 87.1563 13.0937 87.4279 13.545L90 18L92.5721 13.545Z" fill="#06F2FC"/>
</g>
<!-- 3 -->
<g>
<circle cx="118" cy="16" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M120.572 11.545C120.844 11.0937 121 10.5651 121 10C121 8.34315 119.657 7 118 7C116.343 7 115 8.34315 115 10C115 10.5651 115.156 11.0937 115.428 11.545L118 16L120.572 11.545Z" fill="#06F2FC"/>
</g>
<!-- 4 -->
<g>
<circle cx="85" cy="43" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M87.5721 38.545C87.8437 38.0937 88 37.5651 88 37C88 35.3431 86.6569 34 85 34C83.3431 34 82 35.3431 82 37C82 37.5651 82.1563 38.0937 82.4279 38.545L85 43L87.5721 38.545Z" fill="#06F2FC"/>
</g>
<!-- 5 -->
<g>
<circle cx="86" cy="38" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M88.5721 33.545C88.8437 33.0937 89 32.5651 89 32C89 30.3431 87.6569 29 86 29C84.3431 29 83 30.3431 83 32C83 32.5651 83.1563 33.0937 83.4279 33.545L86 38L88.5721 33.545Z" fill="#06F2FC"/>
</g>
<!-- 6 -->
<g>
<circle cx="61" cy="28" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M63.5721 23.545C63.8437 23.0937 64 22.5651 64 22C64 20.3431 62.6569 19 61 19C59.3431 19 58 20.3431 58 22C58 22.5651 58.1563 23.0937 58.4279 23.545L61 28L63.5721 23.545Z" fill="#06F2FC"/>
</g>
<!-- 7 -->
<g>
<circle cx="119" cy="28" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M121.572 23.545C121.844 23.0937 122 22.5651 122 22C122 20.3431 120.657 19 119 19C117.343 19 116 20.3431 116 22C116 22.5651 116.156 23.0937 116.428 23.545L119 28L121.572 23.545Z" fill="#06F2FC"/>
</g>
<!-- 8 -->
<g>
<circle cx="90" cy="58" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M92.5721 53.545C92.8437 53.0937 93 52.5651 93 52C93 50.3431 91.6569 49 90 49C88.3431 49 87 50.3431 87 52C87 52.5651 87.1563 53.0937 87.4279 53.545L90 58L92.5721 53.545Z" fill="#06F2FC"/>
</g>
<!-- 9 -->
<g>
<circle cx="121" cy="56" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M123.572 51.545C123.844 51.0937 124 50.5651 124 50C124 48.3431 122.657 47 121 47C119.343 47 118 48.3431 118 50C118 50.5651 118.156 51.0937 118.428 51.545L121 56L123.572 51.545Z" fill="#06F2FC"/>
</g>
<!-- 10 -->
<g>
<circle cx="128" cy="145" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M130.572 140.545C130.844 140.094 131 139.565 131 139C131 137.343 129.657 136 128 136C126.343 136 125 137.343 125 139C125 139.565 125.156 140.094 125.428 140.545L128 145L130.572 140.545Z" fill="#06F2FC"/>
</g>
<!-- 11 -->
<g>
<circle cx="108" cy="149" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M110.572 144.545C110.844 144.094 111 143.565 111 143C111 141.343 109.657 140 108 140C106.343 140 105 141.343 105 143C105 143.565 105.156 144.094 105.428 144.545L108 149L110.572 144.545Z" fill="#06F2FC"/>
</g>
</svg>
    `,
    measurements: [
      {
        key: '褲長',
        distanceDefinition: { from: 2, to: 9, distance: 'z' },
        definition: 'trouser_length_of_pants',
      },
      {
        key: '腰寬',
        distanceDefinition: [
          { from: 0, to: 1, distance: 'z' },
          { from: 1, to: 2, distance: 'z' },
        ],
        definition: 'trouser_width_of_waist',
      },
      {
        key: '臀寬',
        distanceDefinition: { from: 5, to: 6, distance: 'z' },
        definition: 'trouser_width_of_hip',
      },
      {
        key: '褲襠長',
        distanceDefinition: [
          { from: 1, to: 4, distance: 'z' },
          { from: 4, to: 3, distance: 'z' },
        ],
        definition: 'trouser_length_of_pants_crotch',
      },
      {
        key: '大腿寬',
        distanceDefinition: { from: 7, to: 8, distance: 'z' },
        definition: 'trouser_width_of_thighs',
      },
      {
        key: '褲口寬',
        distanceDefinition: { from: 9, to: 10, distance: 'z' },
        definition: 'trouser_width_of_pants',
      },
    ],
    auxiliaryLines: [
      { auxiliaryPoints: [5, 6], value: 'width_of_hip', referencePoint: { from: 1, to: 1 }, parallel: [0, 2] },
      { auxiliaryPoints: [7], value: 0, referencePoint: { from: 8, to: 8 }, rotate: true },
      { auxiliaryPoints: [8], value: 0, referencePoint: { from: 7, to: 7 }, rotate: true },
    ],
  },
  short: {
    svgHtml: `
<svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="160" height="160" fill="#252736"/>
<path d="M80.3564 36.4281C90.5755 36.4281 121.168 34.1338 121.168 34.1338L144.713 118.566L90.5663 126.825L80.3564 93.5207M80.3564 36.4281C70.1374 36.4281 39.5446 34.1338 39.5446 34.1338L16 118.566L70.1466 126.825L80.3564 93.5207M80.3564 36.4281C77.9474 80.4796 73.8175 85.0683 73.8175 85.0683C73.3587 87.3626 80.3564 93.5207 80.3564 93.5207M37.4521 41.9208C37.4521 41.9208 69.6143 44.3345 80.3564 44.3345C91.0986 44.3345 123.261 41.9208 123.261 41.9208" stroke="white" stroke-width="2" stroke-miterlimit="10" opacity="0.3" />
<path d="M76.3273 76.5518C76.3273 76.5518 76.6072 76.694 77.1028 77.0382" stroke="white" stroke-width="2" stroke-miterlimit="10" opacity="0.3" />
<path d="M78.5439 78.1582C82.9904 81.9852 92.9112 93.6909 96.8253 124.008" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-dasharray="3.99 3.99" opacity="0.3" />
<path d="M96.9402 124.927C96.977 125.23 97.0137 125.532 97.0504 125.84" stroke="white" stroke-width="2" stroke-miterlimit="10" opacity="0.3"/>
<!-- 1 -->
<g>
<circle cx="40" cy="34" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M42.5721 29.545C42.8437 29.0937 43 28.5651 43 28C43 26.3431 41.6569 25 40 25C38.3431 25 37 26.3431 37 28C37 28.5651 37.1563 29.0937 37.4279 29.545L40 34L42.5721 29.545Z" fill="#06F2FC"/>
</g>
<!-- 2 -->
<g>
<circle cx="80" cy="36" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M82.5721 31.545C82.8437 31.0937 83 30.5651 83 30C83 28.3431 81.6569 27 80 27C78.3431 27 77 28.3431 77 30C77 30.5651 77.1563 31.0937 77.4279 31.545L80 36L82.5721 31.545Z" fill="#06F2FC"/>
</g>
<!-- 3 -->
<g>
<circle cx="121" cy="34" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M123.572 29.545C123.844 29.0937 124 28.5651 124 28C124 26.3431 122.657 25 121 25C119.343 25 118 26.3431 118 28C118 28.5651 118.156 29.0937 118.428 29.545L121 34L123.572 29.545Z" fill="#06F2FC"/>
</g>
<!-- 4 -->
<g>
<circle cx="74" cy="85" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M76.5721 80.545C76.8437 80.0937 77 79.5651 77 79C77 77.3431 75.6569 76 74 76C72.3431 76 71 77.3431 71 79C71 79.5651 71.1563 80.0937 71.4279 80.545L74 85L76.5721 80.545Z" fill="#06F2FC"/>
</g>
<!-- 5 -->
<g>
<circle cx="77" cy="77" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M79.5721 72.545C79.8437 72.0937 80 71.5651 80 71C80 69.3431 78.6569 68 77 68C75.3431 68 74 69.3431 74 71C74 71.5651 74.1563 72.0937 74.4279 72.545L77 77L79.5721 72.545Z" fill="#06F2FC"/>
</g>
<!-- 6 -->
<g>
<circle cx="33" cy="56" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M35.5721 51.545C35.8437 51.0937 36 50.5651 36 50C36 48.3431 34.6569 47 33 47C31.3431 47 30 48.3431 30 50C30 50.5651 30.1563 51.0937 30.4279 51.545L33 56L35.5721 51.545Z" fill="#06F2FC"/>
</g>
<!-- 7 -->
<g>
<circle cx="127" cy="56" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M129.572 51.545C129.844 51.0937 130 50.5651 130 50C130 48.3431 128.657 47 127 47C125.343 47 124 48.3431 124 50C124 50.5651 124.156 51.0937 124.428 51.545L127 56L129.572 51.545Z" fill="#06F2FC"/>
</g>
<!-- 8 -->
<g>
<circle cx="80" cy="94" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M82.5721 89.545C82.8437 89.0937 83 88.5651 83 88C83 86.3431 81.6569 85 80 85C78.3431 85 77 86.3431 77 88C77 88.5651 77.1563 89.0937 77.4279 89.545L80 94L82.5721 89.545Z" fill="#06F2FC"/>
</g>
<!-- 9 -->
<g>
<circle cx="138" cy="94" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M140.572 89.545C140.844 89.0937 141 88.5651 141 88C141 86.3431 139.657 85 138 85C136.343 85 135 86.3431 135 88C135 88.5651 135.156 89.0937 135.428 89.545L138 94L140.572 89.545Z" fill="#06F2FC"/>
</g>
<!-- 10 -->
<g>
<circle cx="144" cy="118" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M146.572 113.545C146.844 113.094 147 112.565 147 112C147 110.343 145.657 109 144 109C142.343 109 141 110.343 141 112C141 112.565 141.156 113.094 141.428 113.545L144 118L146.572 113.545Z" fill="#06F2FC"/>
</g>
<!-- 11 -->
<g>
<circle cx="91" cy="126" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M93.5721 121.545C93.8437 121.094 94 120.565 94 120C94 118.343 92.6569 117 91 117C89.3431 117 88 118.343 88 120C88 120.565 88.1563 121.094 88.4279 121.545L91 126L93.5721 121.545Z" fill="#06F2FC"/>
</g>
</svg>
    `,
    measurements: [
      {
        key: '褲長',
        distanceDefinition: { from: 2, to: 9, distance: 'z' },
        definition: 'shorts_length_of_pants',
      },
      {
        key: '腰寬',
        distanceDefinition: [
          { from: 0, to: 1, distance: 'z' },
          { from: 1, to: 2, distance: 'z' },
        ],
        definition: 'shorts_width_of_waist',
      },
      {
        key: '臀寬',
        distanceDefinition: { from: 5, to: 6, distance: 'z' },
        definition: 'shorts_width_of_hip',
      },
      {
        key: '褲襠長',
        distanceDefinition: [
          { from: 1, to: 4, distance: 'z' },
          { from: 4, to: 3, distance: 'z' },
        ],
        definition: 'shorts_length_of_pants_crotch',
      },
      {
        key: '大腿寬',
        distanceDefinition: { from: 7, to: 8, distance: 'z' },
        definition: 'shorts_width_of_thighs',
      },
      {
        key: '褲口寬',
        distanceDefinition: { from: 9, to: 10, distance: 'z' },
        definition: 'shorts_width_of_pants',
      },
    ],
    auxiliaryLines: [
      { auxiliaryPoints: [5, 6], value: 'width_of_hip', referencePoint: { from: 1, to: 1 }, parallel: [0, 2] },
      { auxiliaryPoints: [7], value: 0, referencePoint: { from: 8, to: 8 }, rotate: true },
      { auxiliaryPoints: [8], value: 0, referencePoint: { from: 7, to: 7 }, rotate: true },
    ],
  },
  'long sleeve dress': {
    svgHtml: `
<svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="160" height="160" fill="#252736"/>
<path opacity="0.3" d="M93.3722 18.1338C93.3722 18.1338 98.123 22.2182 110.292 27.664C113.81 29.2387 124.714 56.2545 131.022 88.4756L119.036 90.8582L105.336 47.1782C105.336 47.1782 108.94 86.6603 116.153 130.681C116.153 130.681 99.4112 142.934 79.2889 142.934C59.2077 142.934 42.4246 130.681 42.4246 130.681C49.633 86.6603 53.2418 47.1782 53.2418 47.1782L39.5421 90.8582L27.5555 88.4756C33.864 56.2545 44.768 29.2387 48.2854 27.664C60.4502 22.2182 65.201 18.1338 65.201 18.1338C65.201 18.1338 70.171 23.5796 79.2889 23.5796C88.4433 23.5796 93.3722 18.1338 93.3722 18.1338Z" stroke="white" stroke-width="2" stroke-miterlimit="10"/>
<!-- 1 -->
<g>
<circle cx="93" cy="18" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M95.5721 13.545C95.8437 13.0937 96 12.5651 96 12C96 10.3431 94.6569 9 93 9C91.3431 9 90 10.3431 90 12C90 12.5651 90.1563 13.0937 90.4279 13.545L93 18L95.5721 13.545Z" fill="#06F2FC"/>
</g>
<!-- 2 -->
<g>
<circle cx="111" cy="28" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M113.572 23.545C113.844 23.0937 114 22.5651 114 22C114 20.3431 112.657 19 111 19C109.343 19 108 20.3431 108 22C108 22.5651 108.156 23.0937 108.428 23.545L111 28L113.572 23.545Z" fill="#06F2FC"/>
</g>
<!-- 3 -->
<g>
<circle cx="105" cy="45" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M107.572 40.545C107.844 40.0937 108 39.5651 108 39C108 37.3431 106.657 36 105 36C103.343 36 102 37.3431 102 39C102 39.5651 102.156 40.0937 102.428 40.545L105 45L107.572 40.545Z" fill="#06F2FC"/>
</g>
<!-- 4 -->
<g>
<circle cx="116" cy="131" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M118.572 126.545C118.844 126.094 119 125.565 119 125C119 123.343 117.657 122 116 122C114.343 122 113 123.343 113 125C113 125.565 113.156 126.094 113.428 126.545L116 131L118.572 126.545Z" fill="#06F2FC"/>
</g>
<!-- 5 -->
<g>
<circle cx="84" cy="143" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M86.5721 138.545C86.8437 138.094 87 137.565 87 137C87 135.343 85.6569 134 84 134C82.3431 134 81 135.343 81 137C81 137.565 81.1563 138.094 81.4279 138.545L84 143L86.5721 138.545Z" fill="#06F2FC"/>
</g>
<!-- 6 -->
<g>
<circle cx="77" cy="143" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M79.5721 138.545C79.8437 138.094 80 137.565 80 137C80 135.343 78.6569 134 77 134C75.3431 134 74 135.343 74 137C74 137.565 74.1563 138.094 74.4279 138.545L77 143L79.5721 138.545Z" fill="#06F2FC"/>
</g>
<!-- 7 -->
<g>
<circle cx="43" cy="131" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M45.5721 126.545C45.8437 126.094 46 125.565 46 125C46 123.343 44.6569 122 43 122C41.3431 122 40 123.343 40 125C40 125.565 40.1563 126.094 40.4279 126.545L43 131L45.5721 126.545Z" fill="#06F2FC"/>
</g>
<!-- 8 -->
<g>
<circle cx="106" cy="57" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M108.572 52.545C108.844 52.0937 109 51.5651 109 51C109 49.3431 107.657 48 106 48C104.343 48 103 49.3431 103 51C103 51.5651 103.156 52.0937 103.428 52.545L106 57L108.572 52.545Z" fill="#06F2FC"/>
</g>
<!-- 9 -->
<g>
<circle cx="52" cy="57" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M54.5721 52.545C54.8437 52.0937 55 51.5651 55 51C55 49.3431 53.6569 48 52 48C50.3431 48 49 49.3431 49 51C49 51.5651 49.1563 52.0937 49.4279 52.545L52 57L54.5721 52.545Z" fill="#06F2FC"/>
</g>
<!-- 10 -->
<g>
<circle cx="40" cy="91" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M42.5721 86.545C42.8437 86.0937 43 85.5651 43 85C43 83.3431 41.6569 82 40 82C38.3431 82 37 83.3431 37 85C37 85.5651 37.1563 86.0937 37.4279 86.545L40 91L42.5721 86.545Z" fill="#06F2FC"/>
</g>
<!-- 11 -->
<g>
<circle cx="28" cy="88" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M30.5721 83.545C30.8437 83.0937 31 82.5651 31 82C31 80.3431 29.6569 79 28 79C26.3431 79 25 80.3431 25 82C25 82.5651 25.1563 83.0937 25.4279 83.545L28 88L30.5721 83.545Z" fill="#06F2FC"/>
</g>
<!-- 12 -->
<g>
<circle cx="47" cy="28" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M49.5721 23.545C49.8437 23.0937 50 22.5651 50 22C50 20.3431 48.6569 19 47 19C45.3431 19 44 20.3431 44 22C44 22.5651 44.1563 23.0937 44.4279 23.545L47 28L49.5721 23.545Z" fill="#06F2FC"/>
</g>
</svg>
    `,
    measurements: [
      {
        key: '衣長',
        distanceDefinition: { from: 0, to: [4, 5], distance: 'z' },
        definition: 'long_sleeve_dress_length_of_clothing',
      },
      {
        key: '胸寬',
        distanceDefinition: { from: 7, to: 8, distance: 'z' },
        definition: 'long_sleeve_dress_width_of_chest',
      },
      {
        key: '袖口',
        distanceDefinition: { from: 9, to: 10, distance: 'z' },
        definition: 'long_sleeve_dress_width_of_cuff',
      },
      {
        key: '袖長',
        distanceDefinition: { from: 10, to: 11, distance: 'z' },
        definition: 'long_sleeve_dress_length_of_sleeve',
      },
      {
        key: '下擺寬',
        distanceDefinition: { from: 3, to: 6, distance: 'z' },
        definition: 'long_sleeve_dress_width_of_hem',
      },
      {
        key: '肩寬',
        distanceDefinition: { from: 1, to: 11, distance: 'z' },
        definition: 'long_sleeve_dress_width_of_shoulder',
      },
      {
        key: '袖襱',
        distanceDefinition: { from: 1, to: 2, distance: 'z' },
        definition: 'long_sleeve_dress_width_of_sleeve',
      },
    ],
    auxiliaryLines: [
      { auxiliaryPoints: [4], value: 0, referencePoint: { from: 5, to: 5, base: 0 }, rotate: true },
      { auxiliaryPoints: [5], value: 0, referencePoint: { from: 4, to: 4, base: 0 }, rotate: true },
      { auxiliaryPoints: [7, 8], value: 10, referencePoint: { from: 2, to: 2 }, parallel: [4, 5] },
    ],
  },
  'sling dress': {
    svgHtml: `
<svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="160" height="160" fill="#252736"/>
<path opacity="0.3" d="M53.8848 33.0922C53.8848 33.0922 51.7837 18.3647 55.6209 18.1524C63.2612 17.728 62.4462 24.6037 61.5633 33.0074M104.413 33.0922C104.413 33.0922 106.514 18.3647 102.677 18.1524C95.0364 17.728 95.915 24.6037 96.7936 33.0074M120.355 131.899C109.871 103.887 108.662 71.2057 109.871 48.7111C110.886 29.8411 99.4423 30.6518 95.359 33.8562C91.3775 36.98 88.7331 46.1646 79.2888 46.1646C69.6323 46.1646 67.1789 37.0055 63.2187 33.8562C59.1524 30.6263 47.6919 29.8411 48.7064 48.7111C49.9161 71.2057 48.7064 103.887 38.2222 131.899C38.2222 131.899 68.6561 142.934 79.2888 142.934C89.9216 142.934 120.355 131.899 120.355 131.899Z" stroke="white" stroke-width="2" stroke-miterlimit="10"/>
<!-- 1 -->
<g>
<circle cx="101" cy="32" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M103.572 27.545C103.844 27.0937 104 26.5651 104 26C104 24.3431 102.657 23 101 23C99.3431 23 98 24.3431 98 26C98 26.5651 98.1563 27.0937 98.4279 27.545L101 32L103.572 27.545Z" fill="#06F2FC"/>
</g>
<!-- 2 -->
<g>
<circle cx="120" cy="132" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M122.572 127.545C122.844 127.094 123 126.565 123 126C123 124.343 121.657 123 120 123C118.343 123 117 124.343 117 126C117 126.565 117.156 127.094 117.428 127.545L120 132L122.572 127.545Z" fill="#06F2FC"/>
</g>
<!-- 3 -->
<g>
<circle cx="83" cy="143" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M85.5721 138.545C85.8437 138.094 86 137.565 86 137C86 135.343 84.6569 134 83 134C81.3431 134 80 135.343 80 137C80 137.565 80.1563 138.094 80.4279 138.545L83 143L85.5721 138.545Z" fill="#06F2FC"/>
</g>
<!-- 4 -->
<g>
<circle cx="76" cy="143" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M78.5721 138.545C78.8437 138.094 79 137.565 79 137C79 135.343 77.6569 134 76 134C74.3431 134 73 135.343 73 137C73 137.565 73.1563 138.094 73.4279 138.545L76 143L78.5721 138.545Z" fill="#06F2FC"/>
</g>
<!-- 5 -->
<g>
<circle cx="38" cy="132" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M40.5721 127.545C40.8437 127.094 41 126.565 41 126C41 124.343 39.6569 123 38 123C36.3431 123 35 124.343 35 126C35 126.565 35.1563 127.094 35.4279 127.545L38 132L40.5721 127.545Z" fill="#06F2FC"/>
</g>
<!-- 6 -->
<g>
<circle cx="110" cy="45" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M112.572 40.545C112.844 40.0937 113 39.5651 113 39C113 37.3431 111.657 36 110 36C108.343 36 107 37.3431 107 39C107 39.5651 107.156 40.0937 107.428 40.545L110 45L112.572 40.545Z" fill="#06F2FC"/>
</g>
<!-- 7 -->
<g>
<circle cx="49" cy="45" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M51.5721 40.545C51.8437 40.0937 52 39.5651 52 39C52 37.3431 50.6569 36 49 36C47.3431 36 46 37.3431 46 39C46 39.5651 46.1563 40.0937 46.4279 40.545L49 45L51.5721 40.545Z" fill="#06F2FC"/>
</g>
</svg>
    `,
    measurements: [
      {
        key: '衣長',
        distanceDefinition: { from: 0, to: [2, 3], distance: 'z' },
        definition: 'sling_dress_length_of_clothing',
      },
      {
        key: '胸寬',
        distanceDefinition: { from: 5, to: 6, distance: 'z' },
        definition: 'sling_dress_width_of_chest',
      },
      {
        key: '下擺寬',
        distanceDefinition: { from: 1, to: 4, distance: 'z' },
        definition: 'sling_dress_width_of_hem',
      },
    ],
    auxiliaryLines: [
      { auxiliaryPoints: [2], value: 0, referencePoint: { from: 3, to: 3, base: 0 }, rotate: true },
      { auxiliaryPoints: [3], value: 0, referencePoint: { from: 2, to: 2, base: 0 }, rotate: true },
    ],
  },
  skirt: {
    svgHtml: `
<svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="160" height="160" fill="#252736"/>
<path opacity="0.3" d="M110.105 34.0686C110.105 34.0686 92.0043 40.7971 80.298 40.7971C68.8705 40.7971 50.4914 34.0686 50.4914 34.0686M139.911 117.938L105.571 22.4004C105.571 22.4004 90.1486 30.1744 80.173 30.1744C70.4426 30.1744 54.7797 22.4004 54.7797 22.4004L20.4445 117.938C20.4445 117.938 47.8473 137.6 80.1778 137.6C112.268 137.6 139.911 117.938 139.911 117.938Z" stroke="white" stroke-width="2" stroke-miterlimit="10"/>
<!-- 1 -->
<g>
<circle cx="55" cy="23" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M57.5721 18.545C57.8437 18.0937 58 17.5651 58 17C58 15.3431 56.6569 14 55 14C53.3431 14 52 15.3431 52 17C52 17.5651 52.1563 18.0937 52.4279 18.545L55 23L57.5721 18.545Z" fill="#06F2FC"/>
</g>
<!-- 2 -->
<g>
<circle cx="80" cy="30" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M82.5721 25.545C82.8437 25.0937 83 24.5651 83 24C83 22.3431 81.6569 21 80 21C78.3431 21 77 22.3431 77 24C77 24.5651 77.1563 25.0937 77.4279 25.545L80 30L82.5721 25.545Z" fill="#06F2FC"/>
</g>
<!-- 3 -->
<g>
<circle cx="105" cy="22" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M107.572 17.545C107.844 17.0937 108 16.5651 108 16C108 14.3431 106.657 13 105 13C103.343 13 102 14.3431 102 16C102 16.5651 102.156 17.0937 102.428 17.545L105 22L107.572 17.545Z" fill="#06F2FC"/>
</g>
<!-- 4 -->
<g>
<circle cx="140" cy="117" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M142.572 112.545C142.844 112.094 143 111.565 143 111C143 109.343 141.657 108 140 108C138.343 108 137 109.343 137 111C137 111.565 137.156 112.094 137.428 112.545L140 117L142.572 112.545Z" fill="#06F2FC"/>
</g>
<!-- 5 -->
<g>
<circle cx="84" cy="137.3" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M86.5721 132.845C86.8437 132.394 87 131.865 87 131.3C87 129.643 85.6569 128.3 84 128.3C82.3431 128.3 81 129.643 81 131.3C81 131.865 81.1563 132.394 81.4279 132.845L84 137.3L86.5721 132.845Z" fill="#06F2FC"/>
</g>
<!-- 6 -->
<g>
<circle cx="77" cy="137.3" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M79.5721 132.845C79.8437 132.394 80 131.865 80 131.3C80 129.643 78.6569 128.3 77 128.3C75.3431 128.3 74 129.643 74 131.3C74 131.865 74.1563 132.394 74.4279 132.845L77 137.3L79.5721 132.845Z" fill="#06F2FC"/>
</g>
<!-- 7 -->
<g>
<circle cx="20" cy="117" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22.5721 112.545C22.8437 112.094 23 111.565 23 111C23 109.343 21.6569 108 20 108C18.3431 108 17 109.343 17 111C17 111.565 17.1563 112.094 17.4279 112.545L20 117L22.5721 112.545Z" fill="#06F2FC"/>
</g>
<!-- 8 -->
<g>
<circle cx="120" cy="62" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M122.572 57.545C122.844 57.0937 123 56.5651 123 56C123 54.3431 121.657 53 120 53C118.343 53 117 54.3431 117 56C117 56.5651 117.156 57.0937 117.428 57.545L120 62L122.572 57.545Z" fill="#06F2FC"/>
</g>
<!-- 9 -->
<g>
<circle cx="40" cy="62" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M42.5721 57.545C42.8437 57.0937 43 56.5651 43 56C43 54.3431 41.6569 53 40 53C38.3431 53 37 54.3431 37 56C37 56.5651 37.1563 57.0937 37.4279 57.545L40 62L42.5721 57.545Z" fill="#06F2FC"/>
</g>
</svg>
    `,
    measurements: [
      {
        key: '腰圍',
        distanceDefinition: [
          { from: 0, to: 1, distance: 'z' },
          { from: 1, to: 2, distance: 'z' },
        ],
        definition: 'skirts_width_of_waist',
      },
      {
        key: '裙長',
        distanceDefinition: { from: 2, to: [4, 5], distance: 'z' },
        definition: 'skirts_length_of_skirt',
      },
      {
        key: '臀寬',
        distanceDefinition: { from: 7, to: 8, distance: 'z' },
        definition: 'skirts_width_of_hip',
      },
      {
        key: '下擺寬',
        distanceDefinition: { from: 3, to: 6, distance: 'z' },
        definition: 'skirts_width_of_hem',
      },
    ],
    auxiliaryLines: [
      { auxiliaryPoints: [4], value: 0, referencePoint: { from: 5, to: 5, base: 2 }, rotate: true },
      { auxiliaryPoints: [5], value: 0, referencePoint: { from: 4, to: 4, base: 2 }, rotate: true },
      { auxiliaryPoints: [7, 8], value: 150, referencePoint: { from: 1, to: 1 }, parallel: [4, 5] },
    ],
  },
  legging: {
    svgHtml: `
    <svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="160" height="160" fill="#252736" />
    <path
      opacity="0.3"
      d="M58.1719 19.6523C51.5626 24.6094 62.3025 113.01 60.6504 146.883H75.043C73.3392 113.01 80 51.0468 80 46.916M58.1719 19.6523C58.1719 19.6523 72.1964 22.1309 80 22.1309M58.1719 19.6523C58.1719 19.6523 72.2298 18 80 18C87.7702 18 101.828 19.6523 101.828 19.6523M101.828 19.6523C108.437 24.6094 97.6973 113.01 99.3496 146.883H84.957C86.5579 113.01 80 42.7851 80 46.916M101.828 19.6523C101.828 19.6523 87.8036 22.1309 80 22.1309M80 46.916L80 22.1309M56.5196 24.6094C56.5196 24.6094 72.1964 27.0879 80 27.0879C87.8036 27.0879 103.48 24.6094 103.48 24.6094"
      stroke="white"
      stroke-width="2"
    />
    <!-- 1 -->
    <g>
      <circle cx="58" cy="19" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M60.5721 14.545C60.8437 14.0937 61 13.5651 61 13C61 11.3431 59.6569 10 58 10C56.3431 10 55 11.3431 55 13C55 13.5651 55.1563 14.0937 55.4279 14.545L58 19L60.5721 14.545Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 2 -->
    <g>
      <circle cx="102" cy="19" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M104.572 14.545C104.844 14.0937 105 13.5651 105 13C105 11.3431 103.657 10 102 10C100.343 10 99 11.3431 99 13C99 13.5651 99.1563 14.0937 99.4279 14.545L102 19L104.572 14.545Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 3 -->
    <g>
      <circle cx="103.25" cy="24.4201" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M105.886 19.8402C106.165 19.3763 106.325 18.8329 106.325 18.252C106.325 16.5487 104.948 15.168 103.25 15.168C101.552 15.168 100.175 16.5487 100.175 18.252C100.175 18.8329 100.335 19.3764 100.614 19.8403L103.25 24.42L105.886 19.8402Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 4 -->
    <g>
      <circle cx="80" cy="22" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.5721 17.545C82.8437 17.0937 83 16.5651 83 16C83 14.3431 81.6569 13 80 13C78.3431 13 77 14.3431 77 16C77 16.5651 77.1563 17.0937 77.4279 17.545L80 22L82.5721 17.545Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 5 -->
    <g>
      <circle cx="80" cy="18" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.5721 13.545C82.8437 13.0937 83 12.5651 83 12C83 10.3431 81.6569 9 80 9C78.3431 9 77 10.3431 77 12C77 12.5651 77.1563 13.0937 77.4279 13.545L80 18L82.5721 13.545Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 6 -->
    <g>
      <circle cx="80.25" cy="47.4201" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.8864 42.8402C83.1648 42.3763 83.325 41.8329 83.325 41.252C83.325 39.5487 81.9483 38.168 80.25 38.168C78.5517 38.168 77.175 39.5487 77.175 41.252C77.175 41.8329 77.3352 42.3764 77.6136 42.8403L80.25 47.42L82.8864 42.8402Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 7 -->
    <g>
      <circle cx="80.25" cy="37.4201" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.8864 32.8402C83.1648 32.3763 83.325 31.8329 83.325 31.252C83.325 29.5487 81.9483 28.168 80.25 28.168C78.5517 28.168 77.175 29.5487 77.175 31.252C77.175 31.8329 77.3352 32.3764 77.6136 32.8403L80.25 37.42L82.8864 32.8402Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 8 -->
    <g>
      <circle cx="56.25" cy="36.4201" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M58.8864 31.8402C59.1648 31.3763 59.325 30.8329 59.325 30.252C59.325 28.5487 57.9483 27.168 56.25 27.168C54.5517 27.168 53.175 28.5487 53.175 30.252C53.175 30.8329 53.3352 31.3764 53.6136 31.8403L56.25 36.42L58.8864 31.8402Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 9 -->
    <g>
      <circle cx="104.25" cy="36.4201" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M106.886 31.8402C107.165 31.3763 107.325 30.8329 107.325 30.252C107.325 28.5487 105.948 27.168 104.25 27.168C102.552 27.168 101.175 28.5487 101.175 30.252C101.175 30.8329 101.335 31.3764 101.614 31.8403L104.25 36.42L106.886 31.8402Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 10 -->
    <g>
      <circle cx="85.35" cy="146.42" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M88.0121 141.84C88.2933 141.376 88.455 140.833 88.455 140.252C88.455 138.549 87.0648 137.168 85.35 137.168C83.6352 137.168 82.245 138.549 82.245 140.252C82.245 140.833 82.4067 141.376 82.6879 141.84L85.35 146.42L88.0121 141.84Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 11 -->
    <g>
      <circle cx="79.25" cy="58.4201" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M81.8864 53.8402C82.1648 53.3763 82.325 52.8329 82.325 52.252C82.325 50.5487 80.9483 49.168 79.25 49.168C77.5517 49.168 76.175 50.5487 76.175 52.252C76.175 52.8329 76.3352 53.3764 76.6136 53.8403L79.25 58.42L81.8864 53.8402Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 12 -->
    <g>
      <circle cx="56.35" cy="58.4201" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M59.0121 53.8402C59.2933 53.3763 59.455 52.8329 59.455 52.252C59.455 50.5487 58.0648 49.168 56.35 49.168C54.6352 49.168 53.245 50.5487 53.245 52.252C53.245 52.8329 53.4067 53.3764 53.6879 53.8403L56.35 58.42L59.0121 53.8402Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 13 -->
    <g>
      <circle cx="76.35" cy="96.4201" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M79.0121 91.8402C79.2933 91.3763 79.455 90.8329 79.455 90.252C79.455 88.5487 78.0648 87.168 76.35 87.168C74.6352 87.168 73.245 88.5487 73.245 90.252C73.245 90.8329 73.4067 91.3764 73.6879 91.8403L76.35 96.42L79.0121 91.8402Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 14 -->
    <g>
      <circle cx="59.35" cy="96.4201" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M62.0121 91.8402C62.2933 91.3763 62.455 90.8329 62.455 90.252C62.455 88.5487 61.0648 87.168 59.35 87.168C57.6352 87.168 56.245 88.5487 56.245 90.252C56.245 90.8329 56.4067 91.3764 56.6879 91.8403L59.35 96.42L62.0121 91.8402Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 15 -->
    <g>
      <circle cx="75.35" cy="119.42" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.0121 114.84C78.2933 114.376 78.455 113.833 78.455 113.252C78.455 111.549 77.0648 110.168 75.35 110.168C73.6352 110.168 72.245 111.549 72.245 113.252C72.245 113.833 72.4067 114.376 72.6879 114.84L75.35 119.42L78.0121 114.84Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 16 -->
    <g>
      <circle cx="60.35" cy="119.42" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M63.0121 114.84C63.2933 114.376 63.455 113.833 63.455 113.252C63.455 111.549 62.0648 110.168 60.35 110.168C58.6352 110.168 57.245 111.549 57.245 113.252C57.245 113.833 57.4067 114.376 57.6879 114.84L60.35 119.42L63.0121 114.84Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 17 -->
    <g>
      <circle cx="74.35" cy="146.42" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M77.0121 141.84C77.2933 141.376 77.455 140.833 77.455 140.252C77.455 138.549 76.0648 137.168 74.35 137.168C72.6352 137.168 71.245 138.549 71.245 140.252C71.245 140.833 71.4067 141.376 71.6879 141.84L74.35 146.42L77.0121 141.84Z"
        fill="#06F2FC"
      />
    </g>
    <!-- 18 -->
    <g>
      <circle cx="61.35" cy="146.42" r="1" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M64.0121 141.84C64.2933 141.376 64.455 140.833 64.455 140.252C64.455 138.549 63.0648 137.168 61.35 137.168C59.6352 137.168 58.245 138.549 58.245 140.252C58.245 140.833 58.4067 141.376 58.6879 141.84L61.35 146.42L64.0121 141.84Z"
        fill="#06F2FC"
      />
    </g>
  </svg>
    `,
    measurements: [
      {
        key: 'Waistband_height',
        distanceDefinition: { from: 1, to: 2, distance: 'z' },
        definition: 'legging_waistband_height',
      },
      {
        key: 'Front_rise_including_WB',
        distanceDefinition: { from: 3, to: 5, distance: 'z' },
        definition: 'legging_front_rise_including_wb',
      },
      {
        key: 'Back_rise_including_WB',
        distanceDefinition: { from: 4, to: 5, distance: 'z' },
        definition: 'legging_back_rise_including_wb',
      },
      {
        key: 'Waist_width',
        distanceDefinition: [
          { from: 0, to: 3, distance: 'z' },
          { from: 3, to: 1, distance: 'z' },
        ],
        definition: 'legging_waist_width',
      },
      {
        key: 'Hip_width',
        distanceDefinition: [
          { from: 7, to: 6, distance: 'z' },
          { from: 6, to: 8, distance: 'z' },
        ],
        definition: 'legging_hip_width',
      },
      {
        key: 'Inseam',
        distanceDefinition: { from: 5, to: 9, distance: 'z' },
        definition: 'legging_inseam',
      },
      {
        key: 'Thigh_width',
        distanceDefinition: { from: 10, to: 11, distance: 'z' },
        definition: 'legging_thigh_width',
      },
      {
        key: 'Knee_width',
        distanceDefinition: { from: 12, to: 13, distance: 'z' },
        definition: 'legging_knee_width',
      },
      {
        key: 'Calf_width',
        distanceDefinition: { from: 14, to: 15, distance: 'z' },
        definition: 'legging_calf_width',
      },
      {
        key: 'Leg_opening',
        distanceDefinition: { from: 16, to: 17, distance: 'z' },
        definition: 'legging_leg_opening',
      },
    ],
    auxiliaryLines: [
      { auxiliaryPoints: [6], value: 241, referencePoint: { from: 3, to: 3 } },
      { auxiliaryPoints: [7], value: 241, referencePoint: { from: 0, to: 0 } },
      { auxiliaryPoints: [8], value: 241, referencePoint: { from: 1, to: 1 } },
      { auxiliaryPoints: [10], value: 25, referencePoint: { from: 5, to: 5 } },
      { auxiliaryPoints: [11], value: 0, referencePoint: { from: 10, to: 10 } },
      { auxiliaryPoints: [12], value: 330, referencePoint: { from: 5, to: 5 } },
      { auxiliaryPoints: [13], value: 0, referencePoint: { from: 12, to: 12 } },
      { auxiliaryPoints: [14], value: 127, referencePoint: { from: 12, to: 12 } },
      { auxiliaryPoints: [15], value: 0, referencePoint: { from: 14, to: 14 } },
    ],
  },
};
